import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import { RootState } from './states/RootState'

import { cart } from './modules/Cart'
import { configurator } from './modules/Configurator'

Vue.use(Vuex)

const store: StoreOptions<RootState> = {
  modules: {
    cart,
    configurator,
  },
}

export default new Vuex.Store<RootState>(store)
